import { Component, OnInit, Inject } from '@angular/core';
import { DataService } from '../data.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { identifierModuleUrl } from '@angular/compiler';

export const MY_FORMATS = {
  parse: {
    dateInput: 'L', 
  },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

@Component({
  selector: 'app-producto-edit',
  templateUrl: './producto-edit.component.html',
  styleUrls: ['./producto-edit.component.css'],
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    {provide: MAT_DATE_LOCALE, useValue: "es-MX" },
  ]    
})
export class ProductoEditComponent implements OnInit {
  errMsg:any;
  okMsg:any;
  loading:boolean=false;
  tiempoMsg:number=3200;
  activo:boolean;
  esNuevo:boolean;
  cats:any=[];
  idGpo:number = 0;
  exps:any=[];
  idExp:number = -1;
  prods:any=[];
  tieneProxPrecio:boolean=true;
  fechaIni = moment().add(1, 'day');
  resultado:any=[];
  esDuplicado:boolean = false;
  
  thisForm = new FormGroup({
    prod: new FormControl(this.data.item.prod, [Validators.required, Validators.minLength(4)]),
    cat: new FormControl(this.data.item.cat, [Validators.required, Validators.minLength(1)]),
    exp: new FormControl(this.data.item.relExp, []),
    descrip: new FormControl(this.data.item.descrip, []),
    precio: new FormControl(this.data.item.subTot, [Validators.required, Validators.minLength(1)]),
    chkFuturo: new FormControl(),
    proxPrecio: new FormControl(this.data.item.proxPrecio, []),
    fecha: new FormControl(this.data.item.proxFecha, []),
  });

  constructor(private dataService: DataService, public dialogRef: MatDialogRef<ProductoEditComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    //console.log(this.data);
    this.loading = true;
    this.thisForm.controls["proxPrecio"].disable();     
    this.thisForm.controls["fecha"].disable();     
    if(this.data){
      if(this.data.id > 0){
        this.esNuevo=false;
        this.idExp = this.data.item.relExp;
        this.idGpo = this.data.item.idGpo;
        setTimeout(() => {
          if(this.data.item.proxPrecio){
            this.thisForm.controls["chkFuturo"].setValue(true);
            this.thisForm.controls["proxPrecio"].enable();
            this.thisForm.controls["fecha"].enable();  
          }
          this.fnCargaRolesAsignados();    
          this.fnCargaDescuentosAsignados();      
        }, 30);
      }
      else{
        this.esNuevo=true;
        setTimeout(() => {
          this.fnCargaRolesAsignados();
          setTimeout(() => {
            this.fnClickRol("TODOS")
          }, 350);
          this.fnCargaDescuentosAsignados();                
        }, 30);
      }
    }
    this.activo = this.data.item.act;
    this.dataService.getExposiciones("1").subscribe(
                      rows => {   
                              this.exps = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnExposicionesCargadas());
    this.dataService.getCategorias().subscribe(
                      rows => {   
                              this.cats = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnCategoriasCargados());
  }

  fnExposicionesCargadas(){
    //console.log(this.exps);
  }
  
  fnCategoriasCargados(){
    //console.log(this.cats);
    this.loading = false;
  }

  fnCargaRolesAsignados(){
    //console.log(this.data.item.rol);
    for(var r = 0; r < this.data.roles.length; r++){
      this.data.roles[r].checked = false;
      for(var ra = 0; ra < this.data.item.rol.length; ra++){
        if(this.data.item.rol[ra].id == this.data.roles[r].idRol){
          this.data.roles[r].checked = true;
          if(this.data.roles[r].idRol == 10){ //--> SIEMPRE CHECK
            setTimeout(() => {
              var aux = <HTMLInputElement>document.getElementById("chkRol_10");
              aux.style.setProperty("color", "gray");
              var aux = <HTMLInputElement>document.getElementById("chkRol_10-input");
              aux.disabled = true;
              for(var a = 0; a < aux.parentNode.childNodes.length; a++){
                if(aux.parentNode.childNodes[a].nodeName  == "DIV"){
                    var aux2 = <HTMLDivElement>aux.parentNode.childNodes[a];
                    if(aux2.classList.contains("mat-checkbox-background"))
                      aux2.style.setProperty("background-color", "gray") 
                }               
              }
            }, 44);
          }
        }
      }
    }
  }

  fnCargaDescuentosAsignados(){
    for(var d = 0; d < this.data.descs.length; d++){
      this.data.descs[d].checked = false;
      for(var da = 0; da < this.data.item.desc.length; da++){
        if(this.data.item.desc[da].id == this.data.descs[d].id){
          this.data.descs[d].checked = true;                        
          if(this.data.descs[d].id == 1){ //--> SIEMPRE CHECK
            console.log("CHECK!")
            setTimeout(() => {
              var aux = <HTMLInputElement>document.getElementById("chkDesc_1");
              aux.style.setProperty("color", "gray");
              var aux = <HTMLInputElement>document.getElementById("chkDesc_1-input");
              aux.disabled = true;
              for(var a = 0; a < aux.parentNode.childNodes.length; a++){
                if(aux.parentNode.childNodes[a].nodeName  == "DIV"){
                    var aux2 = <HTMLDivElement>aux.parentNode.childNodes[a];
                    if(aux2.classList.contains("mat-checkbox-background"))
                      aux2.style.setProperty("background-color", "gray") 
                }               
              }
            }, 44);
          }
        }
      }
    }
  }

  fnKeyPress(t, e){
    this.errMsg="";
    if (!this.dataService.validKey(t,e)){
        this.errMsg="Caracter inválido!";
        setTimeout(() => {
            this.errMsg="";
        }, this.tiempoMsg);
        return false;
    }
    else
      return true;
  }

  fnKeyUp(t, e){
    //console.log(e);
  }

  fnCambiaFecha(tipo, obj){
    if (tipo=="INI"){
      this.data.item.proxFecha = moment(obj.value.format("YYYYMMDD"));
    }
  }

  fnMuestraMensaje(tipo:string, msg:string, changeLoading:boolean, closeDialog:boolean){
    this.okMsg = "";
    this.errMsg = "";
    if(tipo=="OK")
      this.okMsg = msg;
    if(tipo=="ERR")
      this.errMsg = msg;
    setTimeout(() => {
      this.okMsg = "";
      this.errMsg = "";
      if(changeLoading)
        this.loading = !this.loading;
      if(closeDialog)
        this.dialogRef.close();
    }, this.tiempoMsg);
  }

  onChange(idEl, item, tipo){
    //console.log("onChange: " + tipo)
    this.onClick(idEl,item,tipo);
  }

  onClick(idEl, item, tipo){
    //console.log("onClick: " + idEl);
    //console.log(item);
    if(tipo=="CAT" && idEl != undefined){
      this.data.item.cat = idEl;
      this.thisForm.controls["cat"].setValue(idEl);
      this.idGpo = this.dataService.findItemInObject(this.cats, idEl, "idCat").idGpo;
      console.log(this.idGpo);
    }
    if(tipo=="EXP" && idEl != undefined){
      this.idExp = idEl;
      this.data.item.relExp = idEl;
      console.log(this.idExp);
      this.thisForm.controls["exp"].setValue(idEl);
    }
  }

  onBlur(event){
    this.dataService.isProductoDup(this.thisForm.controls["prod"].value).subscribe(
                          rows => {   
                                  this.resultado = <any>rows
                                  },          
                          error => this.errMsg = <any>error,
                          () => this.fnProductoDuplicado());
  }

  fnProductoDuplicado(){
    this.esDuplicado = false;
    if(this.resultado > 0){
      this.fnMuestraMensaje("ERR", "El nombre del producto ya ha sido dado de alta; elija otro o edite el existente.", false, false);
      this.thisForm.controls["prod"].markAsDirty();
      var aux = <HTMLInputElement>document.getElementById("txtProducto");
      this.esDuplicado=true;
      aux.focus();
    }
  }

  fnDesactivar(){
    this.activo = false;
  }

  fnActivar(){
    this.activo = true;
  }

  fnClickFuturo(item){
    //console.log(item);
    setTimeout(() => {
      if(item.checked){
        this.thisForm.controls["proxPrecio"].enable();
        this.thisForm.controls["fecha"].enable();
      }
      else{
        this.thisForm.controls["proxPrecio"].reset();
        this.thisForm.controls["fecha"].reset();
        this.thisForm.controls["proxPrecio"].disable();
        this.thisForm.controls["fecha"].disable();
      }
    }, 50);    
  }

  fnClickRol(ev){
    if(ev=="TODOS"){
      var auxTodos = <HTMLInputElement>document.getElementById("chkRol_TODOS-input");
      if(!auxTodos.checked){
        this.data.roles.forEach(r => {
            setTimeout(() => {
              if(!r.checked){
                r.checked = true;
              }
            }, 25);      
        });
      }
      else{
        this.data.roles.forEach(r => {
          setTimeout(() => {
            if(r.checked && r.idRol > 10){
              r.checked = false;
            }
          }, 25);      
      });
      }
    }
    else{
      this.data.roles.forEach(r => {
        if(r.idRol == ev && r.idRol >= 10){
          setTimeout(() => {
            if(r.checked){
              r.checked = false;
            }
            else{
              r.checked = true;
            }            
          }, 25);
        }
      });
    }
  }

  fnClickDesc(ev){
    if(ev=="TODOS"){
      var auxTodos = <HTMLInputElement>document.getElementById("chkDesc_TODOS-input");
      if(!auxTodos.checked){
        this.data.descs.forEach(d => {
            setTimeout(() => {
              if(!d.checked){
                d.checked = true;
              }
            }, 25);      
        });
      }
      else{
        this.data.descs.forEach(d => {
          setTimeout(() => {
            if(d.checked){
              d.checked = false;
            }
          }, 25);      
      });
      }
    }
    else{
      this.data.descs.forEach(d => {
        if(d.id == ev){
          setTimeout(() => {
            if(d.checked){
              d.checked = false;
            }
            else{
              d.checked = true;
            }            
          }, 25);
        }
      });
    }
  }

  fnGuardar(){
    this.loading = true;
    //console.log(this.data.item);
    if(this.esDuplicado){
      this.fnMuestraMensaje("ERR", "El nombre del 'producto' ya esta dado de alta.", true, false);
      return;
    }
    this.data.item.rol = [];
    this.data.item.roles = "";
    this.data.roles.forEach(r => {
      if(r.checked){
        this.data.item.rol.push({'id':r.idRol,'rol':r.rol,'descrip':r.descrip,'act':r.act});
        this.data.item.roles += r.idRol + ",";
      }      
    });
    if(this.data.item.roles.length > 1)
      this.data.item.roles = this.data.item.roles.substring(0, this.data.item.roles.length-1);
    this.data.item.desc = [];
    this.data.item.descuentos = "";
    this.data.descs.forEach(d => {
      if(d.checked){
        this.data.item.desc.push({'id':d.id,'descuento':d.descuento,'descrip':d.descrip,'act':d.act});
        this.data.item.descuentos += d.id + ",";
      }      
    });
    if(this.data.item.descuentos.length > 1)
      this.data.item.descuentos = this.data.item.descuentos.substring(0, this.data.item.descuentos.length-1);

    var arrRol = [];
    var arrRolAct = [];
    for(var rr = 0; rr < this.data.roles.length; rr++){
      var act = 0;
      arrRol.push(this.data.roles[rr].idRol);
      for(var ir = 0; ir < this.data.item.rol.length; ir++){
        if(this.data.item.rol[ir].id == this.data.roles[rr].idRol){
          act = 1;
          ir = 9999;
        }
      }
      arrRolAct.push(act);
    }
    var arrDesc = [];
    var arrDescAct = [];
    for(var dd = 0; dd < this.data.descs.length; dd++){
      var act = 0;
      arrDesc.push(this.data.descs[dd].id);
      for(var id = 0; id < this.data.item.desc.length; id++){
        if(this.data.item.desc[id].id == this.data.descs[dd].id){
          act = 1;
          id = 9999;
        }
      }
      arrDescAct.push(act);
    }
    //--> Validar precio = 0:  El validador minLenght muestra error cuando el valor es 0 (cero)
    if(this.thisForm.controls["precio"].value == 0){
      this.thisForm.controls["precio"].setValue("0");
    }
             
    if(this.esNuevo){
      console.log("GUARDAR");
      //--> Selección de categoría y precio; en caso de elegir precio futuro, también precio futuro y fecha futura:
      if(this.thisForm.valid){
        //--> Selección de categoría y precio; en caso de ser grupo != 1 validar exposición relacionada
        if(this.idGpo != 1){
          if(this.thisForm.controls["exp"].value == null){
            this.fnMuestraMensaje("ERR", "Capture la 'exposición relacionada' al producto.", true, false);
            return;
          }
        } 
        if(this.thisForm.controls["proxPrecio"].enabled){    //-> Validar precio y fecha futuro       
          if(!this.thisForm.controls["proxPrecio"].value){
            this.fnMuestraMensaje("ERR", "Capture el 'precio futuro' del producto.", true, false);
            return;
          }
          if(!this.thisForm.controls["fecha"].value){
            this.fnMuestraMensaje("ERR", "Capture la 'fecha' a partir de la que inicia el precio futuro.", true, false);
            return;
          }                      
        }
        this.dataService.insProducto(this.thisForm.controls["prod"].value, this.data.item.cat, this.data.item.relExp, 
                                      this.thisForm.controls["descrip"].value, this.activo).subscribe(
                                                              rows => {   
                                                                      this.resultado = <any>rows
                                                                      },          
                                                              error => this.errMsg = <any>error,
                                                              () => this.fnProductoGuardado(arrRol.toString(), arrRolAct.toString(), arrDesc.toString(), arrDescAct.toString())); 
      
      }
      else{
        //console.log(this.thisForm.controls["precio"].errors);
        if(this.thisForm.controls["prod"].errors){
          if(this.thisForm.controls["prod"].errors.required)
            this.fnMuestraMensaje("ERR", "Capture el nombre del 'producto'.", true, false);
          if(this.thisForm.controls["prod"].errors.minlength){
              if(this.thisForm.controls["prod"].errors.minlength.actualLength < this.thisForm.controls["prod"].errors.minlength.requiredLength)
              this.fnMuestraMensaje("ERR", "El nombre del 'producto' debe contener " + this.thisForm.controls["prod"].errors.minlength.requiredLength + " o más caracteres.", true, false)
          }  
          return;
        }

        if(this.thisForm.controls["cat"].errors){
          if(this.thisForm.controls["cat"].errors.required)
            this.fnMuestraMensaje("ERR", "Capture una 'categoría'.", true, false);
          return;
        }
        
        if(this.thisForm.controls["precio"].errors){
          if(this.thisForm.controls["precio"].errors.required)
            this.fnMuestraMensaje("ERR", "Capture el 'precio' del producto.", true, false);
          return;
        }
        //--> Selección de categoría y precio; en caso de ser grupo != 1 validar exposición relacionada
        if(this.idGpo != 1){
          if(this.thisForm.controls["exp"].value == null){
            this.fnMuestraMensaje("ERR", "Capture la 'exposición relacionada' al producto.", true, false);
            return;
          }
        } 
        
        if(this.thisForm.controls["proxPrecio"].enabled){  //--> validar precio y fecha futuros
          if(this.thisForm.controls["proxPrecio"].value.length < 1){
            this.fnMuestraMensaje("ERR", "Capture el 'precio futuro' del producto.", true, false);
            return;
          }
          if(!this.thisForm.controls["fecha"].value){
            this.fnMuestraMensaje("ERR", "Capture la 'fecha' a partir de la que inicia el precio futuro.", true, false);
            return;
          }
        }
      }
    }
    else{
      //console.log("EDITAR");
      //--> Selección de categoría y precio; en caso de elegir precio futuro, también precio futuro y fecha futura:
      //console.log(this.thisForm.valid)
      if(this.thisForm.valid){
        //--> Selección de categoría y precio; en caso de ser grupo != 1 validar exposición relacionada
        if(this.idGpo != 1){
          if(this.thisForm.controls["exp"].value == null){
            this.fnMuestraMensaje("ERR", "Capture la 'exposición relacionada' al producto.", true, false);
            return;
          }
        } 
        if(!this.thisForm.controls["proxPrecio"].enabled){          
          this.dataService.updProducto(this.data.item.idProd, this.data.item.cat, this.data.item.relExp, 
                                       this.thisForm.controls["descrip"].value, 
                                       this.thisForm.controls["precio"].value,  
                                       arrRol.toString(), arrRolAct.toString(), 
                                       arrDesc.toString(), arrDescAct.toString(), 
                                       this.thisForm.controls["proxPrecio"].value, 
                                       this.data.item.proxFecha ? moment(this.data.item.proxFecha).format('YYYY/MM/DD') : null, this.activo).subscribe(
                                    rows => {   
                                            this.resultado = <any>rows
                                            },          
                                    error => this.errMsg = <any>error,
                                    () => this.fnProductoEditado()); 
        }
        else{
          //--> Selección de categoría y precio; en caso de ser grupo != 1 validar exposición relacionada
          if(this.idGpo != 1){
            if(this.thisForm.controls["exp"].value == null){
              this.fnMuestraMensaje("ERR", "Capture la 'exposición relacionada' al producto.", true, false);
              return;
            }
          } 
          if(this.thisForm.controls["proxPrecio"].enabled){  //--> validar precio y fecha futuros
            if(!this.thisForm.controls["proxPrecio"].value){
              this.fnMuestraMensaje("ERR", "Capture el 'precio futuro' del producto.", true, false);
              return;
            }
            if(!this.thisForm.controls["fecha"].value){
              this.fnMuestraMensaje("ERR", "Capture la 'fecha' a partir de la que inicia el precio futuro.", true, false);
              return;
            }                      
          this.dataService.updProducto(this.data.item.idProd, this.data.item.cat, this.data.item.relExp, 
                                       this.thisForm.controls["descrip"].value, 
                                       this.thisForm.controls["precio"].value,  
                                       arrRol.toString(), arrRolAct.toString(), 
                                       arrDesc.toString(), arrDescAct.toString(), 
                                       this.thisForm.controls["proxPrecio"].value, 
                                       this.data.item.proxFecha ? moment(this.data.item.proxFecha).format('YYYY/MM/DD') : null, this.activo).subscribe(
                                    rows => {   
                                            this.resultado = <any>rows
                                            },          
                                    error => this.errMsg = <any>error,
                                    () => this.fnProductoEditado()); 
          }
        }
      }
      else{
        console.log(this.thisForm.controls["cat"].errors);
        console.log(this.thisForm.controls["exp"].errors);
        console.log(this.thisForm.controls["precio"].errors);
        console.log(this.thisForm.controls["proxPrecio"].errors);
        if(this.thisForm.controls["cat"].errors){
          if(this.thisForm.controls["cat"].errors.required)
            this.fnMuestraMensaje("ERR", "Capture una 'categoría'.", true, false);
          return;
        }
        //console.log(this.thisForm.controls["precio"].errors);
        if(this.thisForm.controls["precio"].errors){
          if(this.thisForm.controls["precio"].errors.required)
            this.fnMuestraMensaje("ERR", "Capture el 'precio' del producto.", true, false);
          return;
        }
        if(this.thisForm.controls["proxPrecio"].enabled){  //--> validar precio y fecha futuros
          if(this.thisForm.controls["proxPrecio"].value.length < 1){
            this.fnMuestraMensaje("ERR", "Capture el 'precio futuro' del producto.", true, false);
            return;
          }
          if(!this.thisForm.controls["fecha"].value){
            this.fnMuestraMensaje("ERR", "Capture la 'fecha' a partir de la que inicia el precio futuro.", true, false);
            return;
          }
        }
      }

    }
  }

  fnProductoGuardado(arrRol:string, arrRolAct:string, arrDesc:string, arrDescAct:string){
    //console.log(this.resultado)
    if(this.resultado > 0){
      this.dataService.insRestoProducto(this.resultado, this.data.item.cat, 
                                      this.thisForm.controls["precio"].value,  
                                      arrRol, arrRolAct, arrDesc, arrDescAct, 
                                      this.thisForm.controls["proxPrecio"].value, 
                                      this.data.item.proxFecha ? moment(this.data.item.proxFecha).format('YYYY/MM/DD') : null, ).subscribe(
                                                        rows => {   
                                                                this.resultado = <any>rows
                                                                },          
                                                        error => this.errMsg = <any>error,
                                                        () => this.fnRestoProductoGuardado()); 
    }
    else{
      //console.log("ERROR");
      this.fnMuestraMensaje("ERR", "Error al almacenar producto", true, false);
      setTimeout(() => {
        this.loading = false;
      }, this.tiempoMsg);

    }
  }

  fnRestoProductoGuardado(){
    //console.log(this.resultado);
    if(this.resultado.res > 0){
      this.fnMuestraMensaje("OK", "Registro almacenado", false, true);
    }
    else{
      this.fnMuestraMensaje("ERR", "Error al almacenar registro", true, false);
      setTimeout(() => {
        this.loading = false;
      }, this.tiempoMsg);
    }
  }

  fnProductoEditado(){
    //console.log(this.resultado);
    if(this.resultado.res > 0){
      this.okMsg = "Registro actualizado"
      setTimeout(() => {
        this.okMsg = "";
        this.loading = false;
        this.dialogRef.close();
      }, this.tiempoMsg);
    }
    else{
      this.errMsg = "Error al actualizar registro!"
      setTimeout(() => {
        this.errMsg = "";
        this.loading = false;
        console.log("LOADING:" + this.loading);
      }, this.tiempoMsg);
    }
  }

}
